import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { CheckboxContextProvider } from '../../contexts/context.mjs';
import { checkboxLabel, checkboxLabelHorizontalGap } from './label.vanilla.mjs';

const CheckboxLabel = forwardRef(
  ({
    className: classNameFromProps,
    disabled,
    style: styleFromProps,
    size,
    space,
    ...props
  }, forwardedRef) => {
    const className = classNames(checkboxLabel({ size }), classNameFromProps);
    const styles = Object.assign(
      {},
      assignInlineVars({
        [checkboxLabelHorizontalGap]: space !== void 0 ? `${space}px` : null
      }),
      styleFromProps
    );
    return /* @__PURE__ */ jsx(CheckboxContextProvider, { disabled, size, children: /* @__PURE__ */ jsx(
      StyledLabel,
      {
        "data-scope": "checkbox",
        "data-part": "label",
        ...disabled && getDisabledDataAttribute(),
        className,
        style: styles,
        ref: forwardedRef,
        ...props
      }
    ) });
  }
);
function getDisabledDataAttribute() {
  return { ["data-disabled"]: "" };
}
const StyledLabel = styled(Primitive.label);
CheckboxLabel.displayName = "Checkbox.Label";

export { CheckboxLabel };
//# sourceMappingURL=Label.mjs.map
